import React from 'react';
import './StepBlock.scss';

export type StepBlockProps = {
    title: string;
    subtitle?: string;
    className?: string;
} & React.ComponentPropsWithoutRef<'div'>;

export const StepBlock: React.FC<StepBlockProps> = ({ title, subtitle, children, className }) => {
    return (
        <div className={`step-block ${className ? className : ''}`} key={title}>
            <h2 className="title">{title}</h2>
            {subtitle && <p className="subtitle">{subtitle}</p>}
            <div className="content">{children}</div>
        </div>
    );
};
